<template>
  <div class="page-container">
    <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
      <van-sticky>
        <div class="page-top">
          <SearchBar
            @search="search"
            @focus="isShowBottomBtn = false"
            @blur="isShowBottomBtn = true"
            @click-screen="toggleScreen(true)"
            :has-screen="true"
            v-model="searchVal"
            placeholder="搜索用户名称/手机号"
          />
          <TabBarWrp class="tab-bar">
            <van-tabs
              :color="primaryColor"
              line-width="28px"
              :title-inactive-color="blackColor6"
              :title-active-color="primaryColor"
              v-model:active="prepareStatus"
              @click-tab="onClickTab"
            >
              <van-tab v-for="item in tabColum" :name="item.key" :key="item.key" :title="item.title" />
            </van-tabs>
          </TabBarWrp>
        </div>
      </van-sticky>
      <div class="list-wrp">
        <div class="list-box">
          <van-list
            :immediate-check="false"
            v-model:loading="loading"
            :finished="finished"
            :finished-text="finishedText"
            @load="getList"
          >
            <CheckListItem
              v-for="(item, index) in list"
              v-bind="item"
              :key="index"
              @click="navigateTo(`/quasiAgentCheck/details?joinId=${item.joinId}`)"
              class="list-item"
            />
          </van-list>
          <van-empty
            v-if="list.length == 0 && !loading"
            image-size="240"
            image="https://i.xurl.cn/x_dsx_wxapp/empty/result.png"
            description="暂无数据"
          />
        </div>
        <RightSideScreen
          @screen="handleSideScreen"
          @reset="handleSideReset"
          v-model:show="showRightSideScreen"
          :screen-filed="screenFiled"
        />
        <van-popup v-model:show="time.timeWhen" position="bottom">
          <van-date-picker
            v-model="showTime"
            title="选择年月日"
            @confirm="onConfirmTime"
            @cancel="onCancelTime"
            :min-date="minDate"
            :max-date="maxDate"
          />
        </van-popup>
        <back-top />
      </div>
    </van-pull-refresh>
  </div>
</template>
<script setup>
import { ref, computed, onMounted, reactive } from 'vue'
import useTime from '@/utils/time'
import { useCssVar } from '@vueuse/core'
import { useRouter } from 'vue-router'
import { useToggle } from '@vant/use'
import { getAgentJoinList } from '@/api/quasiAgentCheck'
import { Toast } from 'vant'
import { useAgentLevel } from '@/hooks/useBusiness'
import { RightSideScreen, TabBarWrp, BackTop, SearchBar } from '@/components'
import CheckListItem from './component/CheckListItem.vue'
import { tabColum, checkTypeEnum } from './check.data'
import usePage from '@/hooks/usePage'
// import { useUserStore } from '@/store/user'
// import { getLocal } from '@/common/js/utils'

const { quasiAgentList } = useAgentLevel()
const { navigateTo } = usePage()
const router = useRouter()
const { currentRoute } = router
const query = currentRoute.value.query
const defaultRankType = Number(query.rankType) || tabColum[0].key
const minDate = new Date(2020, 0, 1)
const maxDate = new Date(2025, 10, 1)

const pageParams = reactive({
  page: 1,
  pageSize: 20
})

const prepareStatus = ref(defaultRankType)
const searchVal = ref('')
const isShowBottomBtn = ref(true)

const levelList = ref(0)
const refreshing = ref(false)
const loading = ref(false)
const finished = ref(false)
const list = ref([])
const agentLevelData = computed(() => [{ label: '全部', value: 0 }, ...quasiAgentList.value])
const { time, show_time: showTime, timeChangeShow, onConfirmTime, onCancelTime } = useTime()

const screenFiled = ref([
  {
    key: 'level',
    label: '代理级别',
    filedType: 'tag',
    value: levelList,
    options: agentLevelData,
    selectType: 'radio'
  },
  {
    key: 'time',
    label: '注册时间',
    filedType: 'time',
    time,
    timeChangeShow,
    showTime,
    onConfirmTime,
    onCancelTime
  }
])
const isFistLoadList = ref(true)

const finishedText = computed(() => (list.value.length ? '到达地平线' : ''))

const reset = () => {
  pageParams.page = 1
  list.value = []
  finished.value = false
}

const search = () => {
  reset()
  getList()
}

// const onLoad = async () => {
//   reset()
//   getList()
// }

const [showRightSideScreen, toggleScreen] = useToggle()

const handleSideScreen = () => {
  toggleScreen(false)
  search()
}

const handleSideReset = () => {
  levelList.value = 0
  handleSideScreen()
}

const onClickTab = () => {
  search()
}

const getList = async () => {
  // console.log(levelList.value);
  try {
    // console.log(time);
    const params = {
      inPrepare: 1, //是否考核中
      prepareStatus: prepareStatus.value,
      keyword: searchVal.value,
      level: levelList.value,
      dateStart: time.startDate,
      dateEnd: time.endDate,
      ...pageParams
    }
    loading.value = true
    const resData = await getAgentJoinList(params)
    const resList = resData.list.map(d => ({
      joinId: d.joinId,
      headImage: d.avatarUrl,
      name: d.fullname,
      userId: d.puid,
      mobile: d.mobile,
      time: d.changedTime,
      situation: `${d.prepareActualTxt}${
        [checkTypeEnum.LOADING, checkTypeEnum.NOT_STANDARD].includes(d.prepareStatus)
          ? `（距离标准：${d.distanceStandTxt}）`
          : ''
      }`
    }))
    list.value.push(...resList)
    pageParams.page++
    finished.value = list.value.length === Number(resData.total)
  } catch (e) {
    finished.value = true
    console.log(e)
  } finally {
    isFistLoadList.value = false
    loading.value = false
  }
}

const onRefresh = async () => {
  refreshing.value = true
  try {
    // prepareStatus.value = defaultRankType
    // await onLoad()
    // getList()
    search()
  } finally {
    refreshing.value = false
  }
}

const primaryColor = useCssVar('--van-primary-color', document.documentElement)
const blackColor6 = useCssVar('--van-black-6', document.documentElement)
// const userStore = useUserStore()
// const theme = computed(() => userStore.getTheme)

onMounted(() => {
  getList()
  // primaryColor.value = theme.value.PrimaryButtonColor
})
</script>
<style lang="less" scoped>
.page-top {
  padding-top: 16px;
  background-color: #fff;
}

.tab-bar {
  padding-top: 10px;
  :deep(.van-tab) {
    margin-right: 12px;
    &:nth-last-child(2) {
      margin-right: 0px;
    }
  }
}
.list-wrp {
  padding: 12px;
  // margin-top: 8px;
  border-radius: 12px 12px 0px 0px;
  // background-color: var(--van-white);
  font-size: 14px;
  .list-title {
    padding: 0 8px;
    margin-bottom: 13px;
    text-align: center;
    color: var(--van-black-6);
  }
  .list-box {
    // padding-top: 10px;
    padding-bottom: 60px;
    .list-item {
      padding: 10px 8px;
      + .list-item {
        margin-top: 12px;
      }
    }
  }
}
</style>
